import React, { useState, useEffect } from 'react'
import { RestApi } from '../../RestApi'
import GLOBAL from '../../Globals'
import {
    Table,
    Button,
    Modal,
    Input,
    Popconfirm,
    notification,
    Form,
    Radio,
} from 'antd'
import { EditOutlined } from '@ant-design/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { getMessageSalesUserNumber } from '../JS/IlUtil'
import ReorderTable from '../Common/ReorderTable'

function WhatsAppSales(props) {
    const [form] = Form.useForm()
    const { TextArea } = Input

    const [isModalVisible, setIsModalVisible] = useState(false)
    const [userData, setUserData] = useState({})
    const [cartData, setCartData] = useState({})
    const [categories, setCategories] = useState([])
    const [templates, setTemplates] = useState([])
    const [selectedCategoryId, setSelectedCategoryId] = useState()
    const [loading, setLoading] = useState(false)
    const [categoryModalVisible, setCategoryModalVisible] = useState(false)
    const [selectedCategoryForEdit, setSelectedCategoryForEdit] = useState({})
    const [addEditCategoryVisible, setAddEditCategoryVisible] = useState(false)
    const [templatesModalVisible, setTemplatesModalVisible] = useState(false)
    const [addEditTemplateModal, setAddEditTemplateModal] = useState(false)
    const [selectedTemplateForEdit, setSelectedTemplateForEdit] = useState({})
    const [reorderModalVisible, setReorderModalVisible] = useState(false)
    const [reorderTemplates, setReorderTemplates] = useState(false)

    const PLACE_HOLDER_FIRST_NAME = 'il_first_name'
    const PLACEHOLDER_LAST_NAME = 'il_last_name'
    const PLACEHOLDER_USER_STREAM = 'il_user_stream'
    const PLACEHOLDER_USER_CART = 'il_user_cart'
    const PLACEHOLDER_SALES_PERSON_FIRST_NAME = 'il_sales_person_first_name'
    const PLACEHOLDER_SALES_PERSON_NUMBER = 'il_sales_person_number'

    useEffect(() => {
        if (props.userData) {
            setUserData(props.userData)
        }

        if (props.cartData) {
            setCartData(props.cartData)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props])

    useEffect(() => {
        if (!selectedCategoryId) {
            return
        }

        getTemplates()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCategoryId])

    const getCategories = () => {
        setLoading(true)

        RestApi.doGet(GLOBAL.URL.WHATSAPP.GET_SALES_TEMPLATE_CATEGORIES)
            .then((res) => {
                setCategories(res.data)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const showModal = () => {
        if (!categories.length) {
            getCategories()
        }

        setIsModalVisible(true)
    }

    const hideModal = () => {
        setIsModalVisible(false)
    }

    const getCategoryOptions = () => {
        var options = []
        categories.forEach((category) => {
            options.push(
                <Radio.Button value={category.uid} key={category.uid}>
                    {category.name}
                </Radio.Button>
            )
        })

        return options
    }

    const getTemplates = () => {
        setLoading(true)

        RestApi.doGet(
            GLOBAL.URL.WHATSAPP.GET_SALES_TEMPLATES + selectedCategoryId
        )
            .then((res) => {
                setTemplates(res.data)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const getTemplateOptions = () => {
        var options = []
        templates.forEach((template) => {
            options.push(
                <li>
                    <Button
                        type="link"
                        style={{ padding: 0 }}
                        onClick={() => sendMessage(template.content)}
                    >
                        {template.name}
                    </Button>
                </li>
            )
        })

        return options
    }

    const getStreamData = () => {
        var data = ''
        if (userData.stream && userData.stream.course) {
            data =
                ' for ' +
                userData.stream.course +
                (userData.stream.level ? ' ' + userData.stream.level : '')
        }

        return data
    }

    const getCartData = () => {
        var data = ''
        if (cartData && cartData.cartItems && cartData.cartItems.length > 0) {
            data = ' in'
            cartData.cartItems.forEach((item, index) => {
                data = data + '\n' + (index + 1) + '. ' + item.courseName
            })
        }

        return data
    }

    const sendMessage = (content) => {
        if (content.includes(PLACE_HOLDER_FIRST_NAME)) {
            content = content.replace(
                PLACE_HOLDER_FIRST_NAME,
                userData.firstName ? userData.firstName : ''
            )
        }

        if (content.includes(PLACEHOLDER_LAST_NAME)) {
            content = content.replace(
                PLACEHOLDER_LAST_NAME,
                userData.lastName ? userData.lastName : ''
            )
        }

        if (content.includes(PLACEHOLDER_USER_STREAM)) {
            content = content.replace(PLACEHOLDER_USER_STREAM, getStreamData())
        }

        if (content.includes(PLACEHOLDER_USER_CART)) {
            content = content.replace(PLACEHOLDER_USER_CART, getCartData())
        }

        if (content.includes(PLACEHOLDER_SALES_PERSON_FIRST_NAME)) {
            content = content.replace(
                PLACEHOLDER_SALES_PERSON_FIRST_NAME,
                GLOBAL.USER_DATA.firstName
            )
        }

        if (content.includes(PLACEHOLDER_SALES_PERSON_NUMBER)) {
            content = content.replace(
                PLACEHOLDER_SALES_PERSON_NUMBER,
                getMessageSalesUserNumber()
            )
        }

        var url =
            'https://api.whatsapp.com/send?phone=' +
            (userData.isd || '+91') +
            userData.phone +
            '&text=' +
            encodeURIComponent(content)

        window.open(url, '_blank')
    }

    const showEditCategories = () => {
        setCategoryModalVisible(true)
        hideModal()
    }

    const hideEditCategories = () => {
        setCategoryModalVisible(false)
        hideAddEditCategoryModal()
        showModal()
    }

    const categoryTableColumns = [
        {
            title: 'Edit',
            dataIndex: 'edit',
            key: 'edit',
            width: 75,
            render: (text, record) => (
                <Button
                    type="link"
                    onClick={() => {
                        showAddEditCategoryModal(record)
                    }}
                    style={{ padding: 0 }}
                >
                    <EditOutlined theme="twoTone" style={{ fontSize: 12 }} />
                </Button>
            ),
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => (
                <Button
                    type="link"
                    onClick={() => {
                        showTemplatesModal(record)
                    }}
                    style={{ padding: 0 }}
                >
                    {record.name}
                </Button>
            ),
        },
        {
            title: 'Delete',
            dataIndex: 'delete',
            key: 'delete',
            render: (text, record) => (
                <Popconfirm
                    title="Are you sure?"
                    onConfirm={() => deleteCategory(record.uid)}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button
                        type="link"
                        style={{
                            border: 'none',
                            color: 'red',
                            padding: 0,
                        }}
                    >
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </Button>
                </Popconfirm>
            ),
        },
    ]

    const showAddEditCategoryModal = (record = {}) => {
        setSelectedCategoryForEdit(record)
        setAddEditCategoryVisible(true)

        if (record.uid) {
            setTimeout(() => {
                form.setFieldsValue({ name: record.name })
            }, 100)
        } else {
            form.resetFields()
        }
    }

    const hideAddEditCategoryModal = () => {
        setAddEditCategoryVisible(false)
    }

    const addOrUpdateCategory = () => {
        form.validateFields()
            .then((values) => {
                setLoading(true)

                var url = GLOBAL.URL.WHATSAPP.ADD_SALES_TEMPLATE_CATEGORY
                if (selectedCategoryForEdit.uid) {
                    url = GLOBAL.URL.WHATSAPP.UPDATE_SALES_TEMPLATE_CATEGORY
                    values.uid = selectedCategoryForEdit.uid
                }

                var formData = new FormData()
                formData.append('payload', JSON.stringify(values))

                RestApi.doPost(url, formData)
                    .then((response) => {
                        notification['success']({
                            message: response.data,
                        })

                        getCategories()
                        hideAddEditCategoryModal()
                    })
                    .catch((error) => {
                        setLoading(false)
                    })
            })
            .catch(() => {
                //empty catch block
            })
    }

    const deleteCategory = (uid) => {
        setLoading(true)

        var payload = {}
        payload.uid = uid

        var formData = new FormData()
        formData.append('payload', JSON.stringify(payload))

        RestApi.doPost(
            GLOBAL.URL.WHATSAPP.DELETE_SALES_TEMPLATE_CATEGORY,
            formData
        )
            .then((response) => {
                notification['success']({
                    message: response.data,
                })

                getCategories()
                setTemplates()
            })
            .catch((error) => {
                setLoading(false)
            })
    }

    const showTemplatesModal = (category) => {
        setSelectedCategoryForEdit(category)
        setTemplatesModalVisible(true)
        setCategoryModalVisible(false)
        setSelectedCategoryId(category.uid)
    }

    const hideTemplatesModal = () => {
        setTemplatesModalVisible(false)
        setCategoryModalVisible(true)
    }

    const templateTableColumns = [
        {
            title: 'Edit',
            dataIndex: 'edit',
            key: 'edit',
            width: 75,
            render: (text, record) => (
                <Button
                    type="link"
                    onClick={() => {
                        showAddEditTemplateModal(record)
                    }}
                    style={{ padding: 0 }}
                >
                    <EditOutlined theme="twoTone" style={{ fontSize: 12 }} />
                </Button>
            ),
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Delete',
            dataIndex: 'delete',
            key: 'delete',
            render: (text, record) => (
                <Popconfirm
                    title="Are you sure?"
                    onConfirm={() => deleteTemplate(record.uid)}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button
                        type="link"
                        style={{
                            border: 'none',
                            color: 'red',
                            padding: 0,
                        }}
                    >
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </Button>
                </Popconfirm>
            ),
        },
    ]

    const showAddEditTemplateModal = (record = {}) => {
        setAddEditTemplateModal(true)
        setSelectedTemplateForEdit(record)

        if (record.uid) {
            setTimeout(() => {
                form.setFieldsValue({
                    name: record.name,
                    content: record.content,
                })
            }, 100)
        } else {
            form.resetFields()
        }
    }

    const hideAddEditTemplateModal = () => {
        setAddEditTemplateModal(false)
        setSelectedTemplateForEdit({})
    }

    const addOrUpdateTemplate = () => {
        form.validateFields(['name', 'content'])
            .then((values) => {
                setLoading(true)

                var url = GLOBAL.URL.WHATSAPP.ADD_SALES_TEMPLATE
                if (selectedTemplateForEdit.uid) {
                    url = GLOBAL.URL.WHATSAPP.UPDATE_SALES_TEMPLATE
                    values.uid = selectedTemplateForEdit.uid
                }

                values.categoryId = selectedCategoryId

                var formData = new FormData()
                formData.append('payload', JSON.stringify(values))

                RestApi.doPost(url, formData)
                    .then((response) => {
                        notification['success']({
                            message: response.data,
                        })

                        getTemplates()
                        hideAddEditTemplateModal()
                    })
                    .catch((error) => {
                        setLoading(false)
                    })
            })
            .catch(() => {
                //empty catch block
            })
    }

    const deleteTemplate = (uid) => {
        setLoading(true)

        var payload = {}
        payload.uid = uid

        var formData = new FormData()
        formData.append('payload', JSON.stringify(payload))

        RestApi.doPost(GLOBAL.URL.WHATSAPP.DELETE_SALES_TEMPLATE, formData)
            .then((response) => {
                notification['success']({
                    message: response.data,
                })

                getTemplates()
            })
            .catch((error) => {
                setLoading(false)
            })
    }

    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 4 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 },
        },
    }

    const reorderTableColumns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
    ]

    const showReorder = (isTemplate = false) => {
        setReorderTemplates(isTemplate)
        setReorderModalVisible(true)
    }

    const hideReorder = () => {
        setReorderModalVisible(false)
    }

    const saveReorder = (data) => {
        var url = GLOBAL.URL.WHATSAPP.REORDER_SALES_TEMPLATE_CATEGORY
        if (reorderTemplates) {
            url = GLOBAL.URL.WHATSAPP.REORDER_SALES_TEMPLATE
        }

        var payload = {}
        payload.data = data

        var formData = new FormData()
        formData.append('payload', JSON.stringify(payload))

        RestApi.doPost(url, formData)
            .then((response) => {
                notification['success']({
                    message: response.data,
                })

                hideReorder()

                if (reorderTemplates) {
                    getTemplates()
                } else {
                    getCategories()
                }
            })
            .catch((error) => {
                setLoading(false)
            })
    }

    return (
        <>
            <Button
                type={props.buttonType || 'default'}
                style={props.buttonStyle || { marginLeft: 20 }}
                size="small"
                onClick={showModal}
            >
                {props.buttonText || 'Send WhatsApp Message'}
            </Button>
            <Modal
                title="Send WhatsApp Message"
                open={isModalVisible}
                onCancel={hideModal}
                footer={null}
                width={600}
            >
                <div>
                    <Button size="small" onClick={showEditCategories}>
                        Manage
                    </Button>
                </div>
                <div style={{ marginTop: 10 }}>
                    <Radio.Group
                        value={selectedCategoryId}
                        onChange={(e) => setSelectedCategoryId(e.target.value)}
                    >
                        {getCategoryOptions()}
                    </Radio.Group>
                </div>
                <div style={{ marginTop: 10 }}>
                    <ol>{getTemplateOptions()}</ol>
                </div>
            </Modal>
            <Modal
                title="WhatsApp Categories"
                open={categoryModalVisible}
                onCancel={hideEditCategories}
                footer={null}
                width={600}
            >
                <div>
                    {addEditCategoryVisible ? (
                        <div>
                            <Form form={form} layout="vertical">
                                <Form.Item
                                    label="Name"
                                    name="name"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Required!',
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                            </Form>
                            <Button
                                size="small"
                                type="primary"
                                onClick={addOrUpdateCategory}
                            >
                                {selectedCategoryForEdit.uid ? 'Update' : 'Add'}
                            </Button>
                            <Button
                                size="small"
                                style={{ marginLeft: 10 }}
                                onClick={hideAddEditCategoryModal}
                            >
                                Cancel
                            </Button>
                        </div>
                    ) : (
                        <>
                            <Button
                                type="primary"
                                size="small"
                                onClick={showAddEditCategoryModal}
                            >
                                Add
                            </Button>
                            <Button
                                size="small"
                                onClick={() => showReorder(false)}
                                style={{ marginLeft: 10 }}
                            >
                                Reorder
                            </Button>
                        </>
                    )}
                </div>
                <Table
                    columns={categoryTableColumns}
                    dataSource={categories}
                    pagination={false}
                    size="small"
                    loading={loading}
                    rowKey="name"
                    style={{ marginTop: 10 }}
                />
            </Modal>
            <Modal
                title="WhatsApp Templates"
                open={templatesModalVisible}
                onCancel={hideTemplatesModal}
                footer={null}
                width={600}
            >
                <h3>{selectedCategoryForEdit.name}</h3>
                <div>
                    {addEditTemplateModal ? (
                        <div>
                            <Form
                                form={form}
                                layout="horizontal"
                                {...formItemLayout}
                            >
                                <Form.Item
                                    label="Name"
                                    name="name"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Required!',
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    label="Content"
                                    name="content"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Required!',
                                        },
                                    ]}
                                >
                                    <TextArea rows={7} />
                                </Form.Item>
                                <span>
                                    {PLACE_HOLDER_FIRST_NAME +
                                        ', ' +
                                        PLACEHOLDER_LAST_NAME +
                                        ' ,' +
                                        PLACEHOLDER_USER_STREAM +
                                        ', ' +
                                        PLACEHOLDER_USER_CART +
                                        ', ' +
                                        PLACEHOLDER_SALES_PERSON_FIRST_NAME +
                                        ', ' +
                                        PLACEHOLDER_SALES_PERSON_NUMBER}
                                </span>
                            </Form>
                            <div style={{ marginTop: 10 }}>
                                <Button
                                    size="small"
                                    type="primary"
                                    onClick={addOrUpdateTemplate}
                                >
                                    {selectedTemplateForEdit.uid
                                        ? 'Update'
                                        : 'Add'}
                                </Button>
                                <Button
                                    size="small"
                                    style={{ marginLeft: 10 }}
                                    onClick={hideAddEditTemplateModal}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <Button
                                type="primary"
                                size="small"
                                onClick={showAddEditTemplateModal}
                            >
                                Add
                            </Button>
                            <Button
                                size="small"
                                onClick={() => showReorder(true)}
                                style={{ marginLeft: 10 }}
                            >
                                Reorder
                            </Button>
                        </div>
                    )}
                </div>
                <Table
                    columns={templateTableColumns}
                    dataSource={templates}
                    pagination={false}
                    size="small"
                    loading={loading}
                    rowKey="name"
                    style={{ marginTop: 10 }}
                />
            </Modal>
            <Modal
                title={'Reorder'}
                open={reorderModalVisible}
                width={600}
                onCancel={hideReorder}
                destroyOnClose={true}
                footer={null}
            >
                <ReorderTable
                    reorderData={reorderTemplates ? templates : categories}
                    columns={reorderTableColumns}
                    onOk={saveReorder}
                />
            </Modal>
        </>
    )
}

export default WhatsAppSales
